import { createElement, removeClass, addClass, remove } from '@syncfusion/ej2-base';
import * as cls from '../base/css-constant';
import { TreeView } from '@syncfusion/ej2-navigations';
import { Dialog } from '@syncfusion/ej2-popups';
import { MaskedTextBox } from '@syncfusion/ej2-inputs';
/**
 * `FilterDialog` module to create filter dialog.
 */
/** @hidden */
var FilterDialog = /** @class */ (function () {
    /**
     * Constructor for the dialog action.
     * @hidden
     */
    function FilterDialog(parent) {
        this.parent = parent;
    }
    /**
     * Creates the member filter dialog for the selected field.
     * @method createFilterDialog
     * @return {void}
     * @hidden
     */
    FilterDialog.prototype.createFilterDialog = function (treeData, fieldName, fieldCaption, target) {
        var editorDialog = createElement('div', {
            id: this.parent.parentID + '_EditorTreeView',
            className: cls.MEMBER_EDITOR_DIALOG_CLASS
        });
        this.parent.element.appendChild(editorDialog);
        this.dialogPopUp = new Dialog({
            animationSettings: { effect: 'Fade' },
            allowDragging: true,
            header: fieldCaption,
            content: this.createTreeView(treeData, fieldCaption),
            isModal: this.parent.renderMode === 'Popup' ? true : this.parent.isAdaptive ? true : false,
            visible: true,
            showCloseIcon: false,
            enableRtl: this.parent.enableRtl,
            width: 'auto',
            height: '350px',
            position: { X: 'center', Y: 'center' },
            buttons: [{
                    buttonModel: {
                        cssClass: cls.OK_BUTTON_CLASS, content: this.parent.localeObj.getConstant('ok'), isPrimary: true
                    }
                },
                {
                    click: this.closeFilterDialog.bind(this),
                    buttonModel: { cssClass: cls.CANCEL_BUTTON_CLASS, content: this.parent.localeObj.getConstant('cancel') }
                }],
            closeOnEscape: true,
            target: target,
            close: this.removeFilterDialog.bind(this)
        });
        this.dialogPopUp.appendTo(editorDialog);
        this.updateCheckedState();
    };
    FilterDialog.prototype.createTreeView = function (treeData, fieldCaption) {
        var _this = this;
        var editorTreeWrapper = createElement('div', {
            id: this.parent.parentID + 'EditorDiv',
            className: cls.EDITOR_TREE_WRAPPER_CLASS
        });
        var searchWrapper = createElement('div', {
            id: this.parent.parentID + '_SearchDiv', attrs: { 'tabindex': '-1' },
            className: cls.EDITOR_SEARCH_WRAPPER_CLASS
        });
        var editorSearch = createElement('input', { attrs: { 'type': 'text' } });
        searchWrapper.appendChild(editorSearch);
        var selectAllWrapper = createElement('div', {
            id: this.parent.parentID + '_AllDiv', attrs: { 'tabindex': '-1' },
            className: cls.SELECT_ALL_WRAPPER_CLASS
        });
        var selectAllContainer = createElement('div', { className: cls.SELECT_ALL_CLASS });
        var treeViewContainer = createElement('div', { className: cls.EDITOR_TREE_CONTAINER_CLASS });
        var promptDiv = createElement('div', {
            className: cls.EMPTY_MEMBER_CLASS + ' ' + cls.ICON_DISABLE,
            innerHTML: this.parent.localeObj.getConstant('noMatches')
        });
        selectAllWrapper.appendChild(selectAllContainer);
        editorTreeWrapper.appendChild(searchWrapper);
        editorTreeWrapper.appendChild(selectAllWrapper);
        editorTreeWrapper.appendChild(promptDiv);
        this.editorSearch = new MaskedTextBox({
            placeholder: this.parent.localeObj.getConstant('search') + ' ' + fieldCaption,
            enableRtl: this.parent.enableRtl,
            cssClass: cls.EDITOR_SEARCH_CLASS,
            change: function (e) {
                _this.parent.eventBase.searchTreeNodes(e, _this.memberTreeView);
                var filterDialog = _this.dialogPopUp.element;
                var liList = [].slice.call(_this.memberTreeView.element.querySelectorAll('li'));
                var disabledList = [].slice.call(_this.memberTreeView.element.querySelectorAll('.' + cls.ICON_DISABLE));
                if (liList.length === disabledList.length) {
                    _this.allMemberSelect.disableNodes([_this.allMemberSelect.element.querySelector('li')]);
                    filterDialog.querySelector('.' + cls.OK_BUTTON_CLASS).setAttribute('disabled', 'disabled');
                    removeClass([promptDiv], cls.ICON_DISABLE);
                }
                else {
                    _this.allMemberSelect.enableNodes([_this.allMemberSelect.element.querySelector('li')]);
                    filterDialog.querySelector('.' + cls.OK_BUTTON_CLASS).removeAttribute('disabled');
                    addClass([promptDiv], cls.ICON_DISABLE);
                }
                _this.updateCheckedState();
            }
        });
        this.editorSearch.appendTo(editorSearch);
        var data = [{ id: 'all', name: 'All', checkedStatus: true }];
        this.allMemberSelect = new TreeView({
            fields: { dataSource: data, id: 'id', text: 'name', isChecked: 'checkedStatus', },
            showCheckBox: true,
            enableRtl: this.parent.enableRtl,
        });
        this.allMemberSelect.appendTo(selectAllContainer);
        editorTreeWrapper.appendChild(treeViewContainer);
        this.memberTreeView = new TreeView({
            fields: { dataSource: treeData, id: 'id', text: 'name', isChecked: 'checkedStatus' },
            showCheckBox: true,
            enableRtl: this.parent.enableRtl,
            nodeChecking: this.validateTreeNode.bind(this),
        });
        this.memberTreeView.appendTo(treeViewContainer);
        return editorTreeWrapper;
    };
    FilterDialog.prototype.validateTreeNode = function (e) {
        if (e.node.classList.contains(cls.ICON_DISABLE)) {
            e.cancel = true;
        }
        else {
            return;
        }
    };
    /**
     * Update filter state while Member check/uncheck.
     * @hidden
     */
    FilterDialog.prototype.updateCheckedState = function () {
        var filterDialog = this.dialogPopUp.element;
        var list = [].slice.call(this.memberTreeView.element.querySelectorAll('li'));
        var visibleNodes = list.filter(function (node) {
            return (!node.classList.contains(cls.ICON_DISABLE));
        });
        var uncheckedNodes = this.getUnCheckedNodes(visibleNodes);
        var checkedNodes = this.getCheckedNodes(visibleNodes);
        var firstNode = this.allMemberSelect.element.querySelector('li').querySelector('span.' + cls.CHECK_BOX_FRAME_CLASS);
        if (checkedNodes.length > 0) {
            if (uncheckedNodes.length > 0) {
                removeClass([firstNode], cls.NODE_CHECK_CLASS);
                addClass([firstNode], cls.NODE_STOP_CLASS);
            }
            else if (uncheckedNodes.length === 0) {
                removeClass([firstNode], cls.NODE_STOP_CLASS);
                addClass([firstNode], cls.NODE_CHECK_CLASS);
            }
            filterDialog.querySelector('.' + cls.OK_BUTTON_CLASS).removeAttribute('disabled');
        }
        else if (uncheckedNodes.length > 0 && checkedNodes.length === 0) {
            removeClass([firstNode], [cls.NODE_CHECK_CLASS, cls.NODE_STOP_CLASS]);
            if (this.getCheckedNodes(list).length === checkedNodes.length) {
                filterDialog.querySelector('.' + cls.OK_BUTTON_CLASS).setAttribute('disabled', 'disabled');
            }
        }
    };
    FilterDialog.prototype.getCheckedNodes = function (treeNodes) {
        var checkeNodes = treeNodes.filter(function (node) {
            return (node.querySelector('.' + cls.CHECK_BOX_FRAME_CLASS).classList.contains(cls.NODE_CHECK_CLASS));
        });
        return checkeNodes;
    };
    FilterDialog.prototype.getUnCheckedNodes = function (treeNodes) {
        var unCheckeNodes = treeNodes.filter(function (node) {
            return (!node.querySelector('.' + cls.CHECK_BOX_FRAME_CLASS).classList.contains(cls.NODE_CHECK_CLASS));
        });
        return unCheckeNodes;
    };
    FilterDialog.prototype.closeFilterDialog = function () {
        this.dialogPopUp.hide();
    };
    FilterDialog.prototype.removeFilterDialog = function () {
        if (document.getElementById(this.parent.parentID + '_EditorTreeView')) {
            remove(document.getElementById(this.parent.parentID + '_EditorTreeView'));
        }
    };
    return FilterDialog;
}());
export { FilterDialog };
